// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__2soOE","left":"Contact_left__1l4gK","form":"Contact_form__1M9Nf","right":"Contact_right__12q4J"};